import React from "react";
import { useUser, useSigninCheck } from "reactfire";
import GameData from "utils/getGameData";
import { useTranslation } from "react-i18next";

const InitializeGameData = () => {
  const { data: user } = useUser();
  const { status: signInstatus, data: signInCheckResult } = useSigninCheck();
  const { t } = useTranslation();

  return signInstatus === "loading" ? (
    <></>
  ) : signInCheckResult?.signedIn === true && user !== null ? (
    <GameData />
  ) : (
    <></>
  );
};

export default InitializeGameData;
